import React from 'react';

// @mui
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';
// components
import { MetaHelmet } from '../../layouts/Helmet/Helmet';
import InspectCarBannerWeb from '../../segment/Inspection/InspectiCarBannerWeb';
import PreOwnedSectionWeb from '../../segment/Inspection/preOwnedCarSection';
import DontSectionService from '../../segment/Inspection/DontRiskSection';
import CertifiedInspectionWeb from '../../segment/Inspection/InspectionInspectionWeb';
import StepsWeb from '../../segment/Inspection/StepsWeb';
import InspectByExpert from '../../segment/Inspection/InspectByExpert';
import InspectionComparisonWeb from '../../segment/Inspection/InspectionComparisonWeb';
import Backed12YearWeb from '../../segment/Inspection/Bcked12YearWeb';
import ReviewSectionWeb from '../../segment/Inspection/TestimonialWeb';
import BookFromAnywereWeb from '../../segment/Inspection/BookFromAnywereWeb';
import HardEarnedSection from '../../segment/Inspection/HardEarnedSection';
import TransparentReportSectionWeb from '../../segment/Inspection/TransparentReportSectionWeb';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

export default function InspectionPageWeb() {
  return (
    <>
      <MetaHelmet title={'Inspection'} companyName={'Focus Motors'} />

      <StyledRoot className="bg-color bg-inspection">
        <Container className="landgmainsection" maxWidth="xl" sx={{ mb: 0 }}>
          <InspectCarBannerWeb />
          <PreOwnedSectionWeb />
          <DontSectionService />
          <HardEarnedSection />
          <CertifiedInspectionWeb />
          <StepsWeb />
          <InspectByExpert />
          <TransparentReportSectionWeb />
          <InspectionComparisonWeb />
          <Backed12YearWeb />
          <ReviewSectionWeb />
          <BookFromAnywereWeb />
          {/* <WhatsappSection /> */}
        </Container>
      </StyledRoot>
    </>
  );
}
